import { useState } from 'react';

function useModal() {
    const [isShowing, setIsShowing] = useState(false);

    function toggle() {
        setIsShowing(!isShowing);
    }

    function setAction( action : any) {
        action();
    }

    return {
        isShowing,
        toggle,
    }
};

export default useModal;